import { render, staticRenderFns } from "./CertificateTypeTemplates.vue?vue&type=template&id=74bb8c46&scoped=true"
import script from "./CertificateTypeTemplates.vue?vue&type=script&lang=ts"
export * from "./CertificateTypeTemplates.vue?vue&type=script&lang=ts"
import style0 from "./CertificateTypeTemplates.vue?vue&type=style&index=0&id=74bb8c46&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74bb8c46",
  null
  
)

export default component.exports